import * as React from 'react';

import {
  SectionContentLinkListIdEight,
  SectionContentLinkListIdFive,
  SectionContentLinkListIdFour,
  SectionContentLinkListIdNine,
  SectionContentLinkListIdOne,
  SectionContentLinkListIdSeven,
  SectionContentLinkListIdSix,
  SectionContentLinkListIdThree,
  SectionContentLinkListIdTwo,
} from 'components/section-content-link-list';
import { TabIdList } from 'components/tab-list';

type dangerousHtmlStringWrapperProps = {
  input: string;
};

export const dangerousHtmlStringWrapper: React.FC<
  dangerousHtmlStringWrapperProps
  /* eslint-disable react/no-danger */
> = ({ input }) => <span dangerouslySetInnerHTML={{ __html: input }} />;

const MAP_LINKS: Record<string, string> = {
  link_privacy_policy: '/privacy-policy',
  link_data_collection: `#${TabIdList.DataCollection}`,
  link_registration_information: `#${SectionContentLinkListIdOne.RegistrationInformation}`,
  link_linked_social_media_information: `#${SectionContentLinkListIdOne.LinkedSocialMediaInformation}`,
  link_profile_verification_information: `#${SectionContentLinkListIdOne.ProfileVerificationInformation}`,
  link_purchase_information: `#${SectionContentLinkListIdOne.PurchaseInformation}`,
  link_geolocation_information: `#${SectionContentLinkListIdOne.GeolocationInformation}`,
  link_device_information: `#${SectionContentLinkListIdOne.DeviceInformation}`,
  link_photo_information: `#${SectionContentLinkListIdOne.PhotoInformation}`,
  link_link_information: `#${SectionContentLinkListIdOne.LinkInformation}`,
  link_messages: `#${SectionContentLinkListIdOne.Messages}`,
  link_bumble_success_stories: `#${SectionContentLinkListIdOne.BumbleSuccessStories}`,
  link_customer_support_contact_information: `#${SectionContentLinkListIdOne.CustomerSupportContactInformation}`,
  link_cookies_and_similar_technology_information: `#${SectionContentLinkListIdOne.CookiesAndSimilarTechnologyInformation}`,
  link_information_usage: `#${TabIdList.InformationUsage}`,
  link_using_your_information: `#${SectionContentLinkListIdTwo.UsingYourInformation}`,
  link_our_matching_algorithms: `#${SectionContentLinkListIdTwo.OurMatchingAlgorithms}`,
  link_moderation_practices: `#${SectionContentLinkListIdTwo.ModerationPractices}`,
  link_lawful_basis: `#${SectionContentLinkListIdTwo.LawfulBasis}`,
  link_information_disclosure: `#${TabIdList.InformationDisclosure}`,
  link_things_to_keep_in_mind: `#${SectionContentLinkListIdThree.ThingsToKeepInMind}`,
  link_bff_profile_sharing: `#${SectionContentLinkListIdThree.BFFProfileSharing}`,
  link_information_sharing: `#${TabIdList.InformationSharing}`,
  link_our_commitments_to_you: `#${SectionContentLinkListIdFour.OurCommitmentsToYou}`,
  link_rights: `#${TabIdList.Rights}`,
  link_right_to_be_informed: `#${SectionContentLinkListIdFive.RightToBeInformed}`,
  link_right_to_access: `#${SectionContentLinkListIdFive.RightToAccess}`,
  link_right_to_rectify: `#${SectionContentLinkListIdFive.RightToRectify}`,
  link_right_to_data_portability: `#${SectionContentLinkListIdFive.RightToDataPortability}`,
  link_right_to_erase: `#${SectionContentLinkListIdFive.RightToErase}`,
  link_right_to_restrict_or_object: `#${SectionContentLinkListIdFive.RightToRestrictOrObject}`,
  link_right_to_complain: `#${SectionContentLinkListIdFive.RightToComplain}`,
  link_rights_related_to_automated_decision_making: `#${SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking}`,
  link_information_storing: `#${TabIdList.InformationStoring}`,
  link_what_happens_when_you_delete_your_account: `#${SectionContentLinkListIdSix.WhatHappensWhenYouDeleteYourAccount}`,
  link_connecting_you_around_the_world: `#${SectionContentLinkListIdSix.ConnectingYouAroundTheWorld}`,
  link_security_and_age: `#${TabIdList.SecurityAndAge}`,
  link_tips_to_keep_your_data_secure: `#${SectionContentLinkListIdSeven.TipsToKeepYourDataSecure}`,
  link_age_restriction_policy: `#${SectionContentLinkListIdSeven.AgeRestrictionPolicy}`,
  link_us_residents: `#${TabIdList.UsResidents}`,
  link_california: `#${SectionContentLinkListIdNine.California}`,
  link_colorado: `#${SectionContentLinkListIdNine.Colorado}`,
  link_connecticut: `#${SectionContentLinkListIdNine.Connecticut}`,
  link_new_jersey: `#${SectionContentLinkListIdNine.NewJersey}`,
  link_oregon: `#${SectionContentLinkListIdNine.Oregon}`,
  link_texas: `#${SectionContentLinkListIdNine.Texas}`,
  link_utah: `#${SectionContentLinkListIdNine.Utah}`,
  link_virginia: `#${SectionContentLinkListIdNine.Virginia}`,
  link_contact_us: `#${TabIdList.ContactUs}`,
  link_our_contact_information: `#${SectionContentLinkListIdEight.OurContactInformation}`,
  link_bff_steps_to_object_bff_mode:
    'https://support.bumbleforfriends.com/hc/en-us/articles/10594109952285-What-steps-should-I-take-if-I-object-to-my-profile-being-shown-on-both-BFF-mode-in-Bumble-and-Bumble-For-Friends',
  terms_url: '/terms',
  feedback_url: '/contact-us',
  cookies_url: '/cookie-policy',
  link_eu_scc:
    'https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_en',
  gdpr_request_url: 'https://services.nathantrust.com/privacycontact',
  ico_url: 'https://ico.org.uk/',
  data_protection_regulator: 'https://ec.europa.eu/newsroom/article29/items/612080/en',
  privacy_url: '/privacy-policy',
};

export const getLinkMarkerUrl = (linkMarker: keyof typeof MAP_LINKS) => {
  return MAP_LINKS[linkMarker];
};

export const isInternalLink: (link: string) => boolean = (link: string) => {
  const fragments = Object.values(MAP_LINKS).filter((item) => item.charAt(0) === '#');

  return fragments.includes(link);
};
